import { api } from '../api';
import type { BannerContent } from './types';

// BUG-09 — no depende de que el saas_admin conserve una notificación sin leer:
// mientras una integración siga pending_review, el aviso permanece en el shell
// hasta que se resuelva desde Ajustes → Legal.
export async function getLegalInventoryBanner(
  navigate: (path: string) => void,
): Promise<BannerContent | null> {
  const { items, pendingCount } = await api.platformLegalInventory.list()
    .catch(() => ({ items: [], pendingCount: 0 }));
  if (!pendingCount) return null;

  const names = items.filter((item) => item.reviewStatus === 'pending_review')
    .slice(0, 2).map((item) => item.service);
  const detail = names.length ? `: ${names.join(', ')}` : '';
  return {
    tone: 'danger',
    message: `${pendingCount} integración${pendingCount === 1 ? '' : 'es'} espera${pendingCount === 1 ? '' : 'n'} revisión antes de activarse${detail}.`,
    actionLabel: 'Revisar pendientes',
    onAction: () => { navigate('/settings/legal'); },
  };
}
